// Auto-generated. Character-level zh-Hant → zh-Hans map.
// Regenerate with scripts/build-tc2sc-map.py when hardcoded Chinese copy changes.

export const TC2SC_MAP: Record<string, string> = {
  "並": "并",
  "乾": "干",
  "亞": "亚",
  "佈": "布",
  "來": "来",
  "倉": "仓",
  "個": "个",
  "們": "们",
  "備": "备",
  "傢": "家",
  "傳": "传",
  "僅": "仅",
  "價": "价",
  "儲": "储",
  "內": "内",
  "兩": "两",
  "冊": "册",
  "別": "别",
  "刪": "删",
  "劑": "剂",
  "動": "动",
  "務": "务",
  "勻": "匀",
  "匯": "汇",
  "區": "区",
  "協": "协",
  "參": "参",
  "員": "员",
  "問": "问",
  "啟": "启",
  "單": "单",
  "嗎": "吗",
  "嚴": "严",
  "國": "国",
  "圍": "围",
  "團": "团",
  "堅": "坚",
  "報": "报",
  "場": "场",
  "塗": "涂",
  "墊": "垫",
  "壓": "压",
  "夥": "伙",
  "學": "学",
  "實": "实",
  "審": "审",
  "寫": "写",
  "將": "将",
  "專": "专",
  "尋": "寻",
  "對": "对",
  "屜": "屉",
  "層": "层",
  "屬": "属",
  "師": "师",
  "帶": "带",
  "庫": "库",
  "廠": "厂",
  "廣": "广",
  "廳": "厅",
  "張": "张",
  "強": "强",
  "彈": "弹",
  "後": "后",
  "從": "从",
  "態": "态",
  "慮": "虑",
  "應": "应",
  "戶": "户",
  "拋": "抛",
  "採": "采",
  "換": "换",
  "損": "损",
  "撥": "拨",
  "擇": "择",
  "據": "据",
  "擺": "摆",
  "攝": "摄",
  "數": "数",
  "於": "于",
  "時": "时",
  "書": "书",
  "會": "会",
  "東": "东",
  "條": "条",
  "業": "业",
  "構": "构",
  "標": "标",
  "樣": "样",
  "機": "机",
  "檔": "档",
  "檢": "检",
  "檻": "槛",
  "櫃": "柜",
  "欄": "栏",
  "歐": "欧",
  "歡": "欢",
  "決": "决",
  "沒": "没",
  "減": "减",
  "測": "测",
  "準": "准",
  "溫": "温",
  "漢": "汉",
  "瀏": "浏",
  "為": "为",
  "烏": "乌",
  "無": "无",
  "營": "营",
  "狀": "状",
  "獲": "获",
  "現": "现",
  "產": "产",
  "畫": "画",
  "當": "当",
  "發": "发",
  "確": "确",
  "碼": "码",
  "稱": "称",
  "積": "积",
  "穩": "稳",
  "窯": "窑",
  "筆": "笔",
  "節": "节",
  "範": "范",
  "篩": "筛",
  "簡": "简",
  "籤": "签",
  "紀": "纪",
  "約": "约",
  "納": "纳",
  "紙": "纸",
  "級": "级",
  "細": "细",
  "紹": "绍",
  "終": "终",
  "組": "组",
  "結": "结",
  "絡": "络",
  "給": "给",
  "統": "统",
  "經": "经",
  "網": "网",
  "線": "线",
  "練": "练",
  "縫": "缝",
  "繫": "系",
  "續": "续",
  "義": "义",
  "聯": "联",
  "腳": "脚",
  "臨": "临",
  "與": "与",
  "興": "兴",
  "舊": "旧",
  "華": "华",
  "蓋": "盖",
  "薦": "荐",
  "藝": "艺",
  "處": "处",
  "號": "号",
  "螢": "萤",
  "術": "术",
  "補": "补",
  "裝": "装",
  "裡": "里",
  "製": "制",
  "複": "复",
  "見": "见",
  "規": "规",
  "視": "视",
  "親": "亲",
  "覽": "览",
  "觀": "观",
  "訂": "订",
  "計": "计",
  "訊": "讯",
  "討": "讨",
  "記": "记",
  "訪": "访",
  "設": "设",
  "訴": "诉",
  "註": "注",
  "評": "评",
  "詢": "询",
  "試": "试",
  "話": "话",
  "詳": "详",
  "認": "认",
  "誠": "诚",
  "誤": "误",
  "說": "说",
  "調": "调",
  "談": "谈",
  "請": "请",
  "論": "论",
  "諾": "诺",
  "謝": "谢",
  "證": "证",
  "識": "识",
  "護": "护",
  "讓": "让",
  "負": "负",
  "貨": "货",
  "貫": "贯",
  "責": "责",
  "貴": "贵",
  "買": "买",
  "貼": "贴",
  "貿": "贸",
  "資": "资",
  "質": "质",
  "購": "购",
  "蹤": "踪",
  "車": "车",
  "軌": "轨",
  "軟": "软",
  "載": "载",
  "輔": "辅",
  "輪": "轮",
  "輸": "输",
  "轉": "转",
  "這": "这",
  "連": "连",
  "週": "周",
  "進": "进",
  "運": "运",
  "過": "过",
  "達": "达",
  "適": "适",
  "選": "选",
  "邊": "边",
  "郵": "邮",
  "針": "针",
  "銷": "销",
  "錄": "录",
  "錯": "错",
  "鍵": "键",
  "鎮": "镇",
  "長": "长",
  "門": "门",
  "閉": "闭",
  "開": "开",
  "閒": "闲",
  "間": "间",
  "閱": "阅",
  "關": "关",
  "陳": "陈",
  "陸": "陆",
  "隊": "队",
  "階": "阶",
  "際": "际",
  "隨": "随",
  "雜": "杂",
  "離": "离",
  "電": "电",
  "頁": "页",
  "項": "项",
  "預": "预",
  "頭": "头",
  "題": "题",
  "顏": "颜",
  "類": "类",
  "顯": "显",
  "風": "风",
  "飯": "饭",
  "飲": "饮",
  "餘": "余",
  "馬": "马",
  "驗": "验",
  "體": "体",
  "點": "点",
  "齊": "齐",
};

export const convertTC2SC = (s: string): string => {
  let out = '';
  for (const ch of s) out += TC2SC_MAP[ch] ?? ch;
  return out;
};
